import { MedicalProtocolsState, MedicalProtocolsUnloadState } from '../states/MedicalProtocolsState';

// MedicalProtocols Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../actions';

// functions
import * as Functions from '../../functions/common';

// Models
import { Protocol } from '../../models/Entities/Protocols/Protocol';
import { ProtocolConsumptionVisit } from '../../models/Entities/Protocols/ProtocolConsumptionVisit';

type KnownAction = 
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitRequestAction
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitSuccessAction
    | Actions.ProtocolConsumptionVisit.GetAllProtocolVisitFailureAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdRequestAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdSuccessAction
    | Actions.ProtocolConsumptionVisit.GetProtocolVisitByIdFailureAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdRequestAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdSuccessAction
    | Actions.ProtocolConsumptionVisit.GetAllConsumptionsByVisitIdFailureAction;

export const MedicalProtocolsConsumptionVisitReducer: Reducer<MedicalProtocolsState> = (
    state: MedicalProtocolsState | undefined, incomingAction: Action): MedicalProtocolsState => {
    
    if (state === undefined) {
        return MedicalProtocolsUnloadState as MedicalProtocolsState;
    }

    const action = incomingAction as KnownAction;

    let CurrentProtocol: Protocol | undefined = undefined;

    let CurrentProtocolVisit: ProtocolConsumptionVisit | undefined = undefined;

    switch (action.type) {
        case 'GET_ALL_PROTOCOL_VISITS_REQUEST':

            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol = {
                    ...CurrentProtocol,
                    ConsumptionVisits: [],
                    isGettingConsumptionsVisits: true,
                    gettingConsumptionsVisitsSuccess: undefined,
                    failOnGettingConsumptionsVisits: false,
                    ErrorOnGettingConsumptionsVisits: undefined
                };
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            }   
        case 'GET_ALL_PROTOCOL_VISITS_SUCCESS':
        
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            console.log('Llego al success', CurrentProtocol);
            if (CurrentProtocol) {
                CurrentProtocol.ConsumptionVisits = action.protocolVisits;
                CurrentProtocol.isGettingConsumptionsVisits = false;
                CurrentProtocol.gettingConsumptionsVisitsSuccess = true;
                CurrentProtocol.failOnGettingConsumptionsVisits = false;
                CurrentProtocol.ErrorOnGettingConsumptionsVisits = undefined;
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };

        case 'GET_ALL_PROTOCOL_VISITS_FAILURE':
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            if (CurrentProtocol) {
                CurrentProtocol.isGettingConsumptionsVisits = false;
                CurrentProtocol.gettingConsumptionsVisitsSuccess = false;
                CurrentProtocol.failOnGettingConsumptionsVisits = true;
                CurrentProtocol.ErrorOnGettingConsumptionsVisits = action.error;
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };
        case 'GET_PROTOCOL_VISIT_BYID_REQUEST':
            
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {
                CurrentProtocol.isGettingVisitsById = true;
                CurrentProtocol.gettingVisitsByIdSuccess = undefined	
                CurrentProtocol.failOnGettingVisitsById = false;
                CurrentProtocol.ErrorOnGettingVisitsById = undefined;
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };
        case 'GET_PROTOCOL_VISIT_BYID_SUCCESS':
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {
                CurrentProtocol.isGettingVisitsById = false;
                CurrentProtocol.gettingVisitsByIdSuccess = true;
                CurrentProtocol.failOnGettingVisitsById = false;
                CurrentProtocol.ErrorOnGettingVisitsById = undefined;
                CurrentProtocol.ConsumptionVisits = [...(CurrentProtocol.ConsumptionVisits ?? []).filter(visit => visit.id != action.visit.id), action.visit] ;
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };
        case 'GET_PROTOCOL_VISIT_BYID_FAILURE':
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {
                CurrentProtocol.isGettingVisitsById = false;
                CurrentProtocol.gettingVisitsByIdSuccess = false;
                CurrentProtocol.failOnGettingVisitsById = true;
                CurrentProtocol.ErrorOnGettingVisitsById = action.error;
            }
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };
        case 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_REQUEST':
            
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {

                CurrentProtocolVisit = CurrentProtocol.ConsumptionVisits?.find((visit) => visit.contractStageId === action.stageId && visit.patientNumberInProtocol === action.patientNumberInProtocol);

                if (CurrentProtocolVisit) {
                    CurrentProtocolVisit.isGettingAllConsumptionsByVisitId = true;
                    CurrentProtocolVisit.gettingAllConsumptionsByVisitIdSuccess = undefined;
                    CurrentProtocolVisit.failOnGettingAllConsumptionsByVisitId = false;
                    CurrentProtocolVisit.errorOnGettingAllConsumptionsByVisitId = undefined;

                    CurrentProtocol.ConsumptionVisits = [...(CurrentProtocol.ConsumptionVisits ?? []).filter(visit => visit.id != CurrentProtocolVisit?.id), CurrentProtocolVisit];
                }             
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };
        case 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_SUCCESS':
            
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {

                CurrentProtocolVisit = CurrentProtocol.ConsumptionVisits?.find((visit) => visit.contractStageId === action.stageId && visit.patientNumberInProtocol === action.patientNumberInProtocol);
                
                if (CurrentProtocolVisit) {
                    CurrentProtocolVisit.isGettingAllConsumptionsByVisitId = false;
                    CurrentProtocolVisit.gettingAllConsumptionsByVisitIdSuccess = true;
                    CurrentProtocolVisit.failOnGettingAllConsumptionsByVisitId = false;
                    CurrentProtocolVisit.errorOnGettingAllConsumptionsByVisitId = undefined;

                    CurrentProtocolVisit.consumptions = action.consumptions;

                    CurrentProtocol.ConsumptionVisits = [...(CurrentProtocol.ConsumptionVisits ?? []).filter(visit => visit.id != CurrentProtocolVisit?.id), CurrentProtocolVisit];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };

        case 'GET_ALL_CONSUMPTIONS_BY_VISIT_ID_FAILURE':
            
            CurrentProtocol = state.list?.find((protocol) => protocol.id === action.protocolId);
            
            if (CurrentProtocol) {

                CurrentProtocolVisit = CurrentProtocol.ConsumptionVisits?.find((visit) => visit.contractStageId === action.stageId && visit.patientNumberInProtocol === action.patientNumberInProtocol);

                if (CurrentProtocolVisit) {
                    CurrentProtocolVisit.isGettingAllConsumptionsByVisitId = false;
                    CurrentProtocolVisit.gettingAllConsumptionsByVisitIdSuccess = false;
                    CurrentProtocolVisit.failOnGettingAllConsumptionsByVisitId = true;
                    CurrentProtocolVisit.errorOnGettingAllConsumptionsByVisitId = action.error;
                    
                    CurrentProtocol.ConsumptionVisits = [...(CurrentProtocol.ConsumptionVisits ?? []).filter(visit => visit.id != CurrentProtocolVisit?.id), CurrentProtocolVisit];
                }
            }
            
            return {
                ...state,
                list: CurrentProtocol ? [...(state.list ?? []).filter((protocol) => protocol.id !== action.protocolId), CurrentProtocol] : state.list,
            };

    default:
        return state;
    }
}